import React from 'react';
import { data } from '../data/data.js';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

const Work = () => {
	const project = data;

	return (
		<div name='work' className='w-full md:h-screen text-gray-300 bg-[#260f38]'>
			<div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
				<div className='pb-8'>
					<p className='text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600'>
						Work
					</p>
					<p className='py-6'>Check out some of my recent work</p>
				</div>

				{/* container for projects */}
				<div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>
					{project.map((item, index) => (
						<div
							key={index}
							style={{ backgroundImage: `url(${item.image})` }}
							className='shadow-lg shadow-[#040c16] group container rounded-md 
								flex justify-center text-center items-center mx-auto content-div bg-cover bg-center'
						>
							{/* Hover effect */}
							<div className='opacity-0 group-hover:opacity-100 bg-black/70 w-full h-full flex flex-col justify-center items-center rounded-md p-4'>
								<span className='text-2xl font-bold text-white tracking-wider'>
									{item.name}
								</span>
								<div className='pt-8 text-center'>
									{item.github && (
										<a href={item.github} target='_blank' rel='noreferrer'>
											<button className='flex items-center gap-2 text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
												<FaGithub />
												Code
											</button>
										</a>
									)}
									{item.live && (
										<a href={item.live} target='_blank' rel='noreferrer'>
											<button className='flex items-center gap-2 text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>
												<FaExternalLinkAlt />
												Live
											</button>
										</a>
									)}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Work;
